function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { AxisRenderer } from "./AxisRenderer";
import { p100 } from "../../../core/util/Percent";
import * as $type from "../../../core/util/Type";
import * as $utils from "../../../core/util/Utils";
import { Rectangle } from "../../../core/render/Rectangle";
/**
 * Used to render vertical axis.
 *
 * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/#Axis_renderer} for more info
 * @important
 */
export var AxisRendererY = /*#__PURE__*/function (_AxisRenderer) {
  _inherits(AxisRendererY, _AxisRenderer);
  var _super = _createSuper(AxisRendererY);
  function AxisRendererY() {
    var _this;
    _classCallCheck(this, AxisRendererY);
    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_downY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "thumb", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Rectangle.new(_this._root, {
        height: p100,
        isMeasured: false,
        themeTags: ["axis", "y", "thumb"]
      })
    });
    return _this;
  }
  _createClass(AxisRendererY, [{
    key: "_afterNew",
    value: function _afterNew() {
      this._settings.themeTags = $utils.mergeTags(this._settings.themeTags, ["renderer", "y"]);
      if (this._settings.opposite) {
        this._settings.themeTags.push("opposite");
      }
      _get(_getPrototypeOf(AxisRendererY.prototype), "_afterNew", this).call(this);
      this.setPrivateRaw("letter", "Y");
      var gridTemplate = this.grid.template;
      gridTemplate.set("width", p100);
      gridTemplate.set("height", 0);
      gridTemplate.set("draw", function (display, graphics) {
        display.moveTo(0, 0);
        display.lineTo(graphics.width(), 0);
      });
      this.set("draw", function (display, renderer) {
        display.moveTo(0, 0);
        display.lineTo(0, renderer.height());
      });
    }
  }, {
    key: "_getPan",
    value: function _getPan(point1, point2) {
      return (point1.y - point2.y) / this.height();
    }
  }, {
    key: "_changed",
    value: function _changed() {
      _get(_getPrototypeOf(AxisRendererY.prototype), "_changed", this).call(this);
      var axis = this.axis;
      axis.ghostLabel.setPrivate("visible", !this.get("inside"));
      axis.ghostLabel.set("y", -1000);
      var thumb = this.thumb;
      var opposite = "opposite";
      var inside = "inside";
      var chart = this.chart;
      if (this.isDirty(opposite) || this.isDirty(inside)) {
        var axisChildren = axis.children;
        if (this.get(inside)) {
          axis.addTag(inside);
        } else {
          axis.removeTag(inside);
        }
        if (chart) {
          if (this.get(opposite)) {
            var children = chart.rightAxesContainer.children;
            if (children.indexOf(axis) == -1) {
              children.moveValue(axis, 0);
            }
            axis.addTag(opposite);
            axisChildren.moveValue(this, 0);
          } else {
            var _children = chart.leftAxesContainer.children;
            if (_children.indexOf(axis) == -1) {
              _children.moveValue(axis);
            }
            axis.removeTag(opposite);
            axisChildren.moveValue(this);
          }
          axis.ghostLabel._applyThemes();
          this.labels.each(function (label) {
            label._applyThemes();
          });
          this.root._markDirtyRedraw();
        }
        axis.markDirtySize();
      }
      var w = axis.labelsContainer.width();
      if (chart) {
        if (this.get(opposite)) {
          thumb.set("centerX", 0);
        } else {
          thumb.set("centerX", w);
        }
      }
      thumb.setPrivate("width", w);
    }
    /**
     * @ignore
     */
  }, {
    key: "processAxis",
    value: function processAxis() {
      _get(_getPrototypeOf(AxisRendererY.prototype), "processAxis", this).call(this);
      var axis = this.axis;
      if (axis.get("height") == null) {
        axis.set("height", p100);
      }
      var horizontalLayout = this._root.horizontalLayout;
      axis.set("layout", horizontalLayout);
      axis.labelsContainer.set("height", p100);
      axis.axisHeader.set("layout", horizontalLayout);
    }
  }, {
    key: "_updatePositions",
    value: function _updatePositions() {
      var axis = this.axis;
      axis.gridContainer.set("y", axis.y() - $utils.relativeToValue(axis.get("centerY", 0), axis.height()));
      axis.bulletsContainer.set("x", this.x());
      var chart = axis.chart;
      if (chart) {
        var plotContainer = chart.plotContainer;
        var axisHeader = axis.axisHeader;
        var height = axis.get("marginTop", 0);
        if (axisHeader.children.length > 0) {
          height = axis.axisHeader.height();
          axis.set("marginTop", height + 1);
        } else {
          axisHeader.set("height", height);
        }
        axisHeader.setAll({
          y: axis.y() - height,
          x: -1,
          width: plotContainer.width() + 2
        });
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "axisLength",
    value: function axisLength() {
      return this.axis.innerHeight();
    }
    /**
     * Converts axis relative position to actual coordinate in pixels.
     *
     * @param   position  Position
     * @return            Point
     */
  }, {
    key: "positionToPoint",
    value: function positionToPoint(position) {
      return {
        x: 0,
        y: this.positionToCoordinate(position)
      };
    }
    /**
     * @ignore
     */
  }, {
    key: "updateLabel",
    value: function updateLabel(label, position, endPosition, count) {
      if (label) {
        if (!$type.isNumber(position)) {
          position = 0;
        }
        var location = 0.5;
        if ($type.isNumber(count) && count > 1) {
          location = label.get("multiLocation", location);
        } else {
          location = label.get("location", location);
        }
        var opposite = this.get("opposite");
        var inside = label.get("inside", this.get("inside", false));
        if (opposite) {
          label.set("x", 0);
          if (inside) {
            label.set("position", "absolute");
          } else {
            label.set("position", "relative");
          }
        } else {
          if (inside) {
            label.set("x", 0);
            label.set("position", "absolute");
          } else {
            label.set("x", undefined);
            label.set("position", "relative");
          }
        }
        if ($type.isNumber(endPosition) && endPosition != position) {
          position = position + (endPosition - position) * location;
        }
        label.set("y", this.positionToCoordinate(position));
        this.toggleVisibility(label, position, label.get("minPosition", 0), label.get("maxPosition", 1));
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "updateGrid",
    value: function updateGrid(grid, position, endPosition) {
      if (grid) {
        if (!$type.isNumber(position)) {
          position = 0;
        }
        var location = grid.get("location", 0.5);
        if ($type.isNumber(endPosition) && endPosition != position) {
          position = position + (endPosition - position) * location;
        }
        grid.set("y", this.positionToCoordinate(position));
        this.toggleVisibility(grid, position, 0, 1);
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "updateTick",
    value: function updateTick(tick, position, endPosition, count) {
      if (tick) {
        if (!$type.isNumber(position)) {
          position = 0;
        }
        var location = 0.5;
        if ($type.isNumber(count) && count > 1) {
          location = tick.get("multiLocation", location);
        } else {
          location = tick.get("location", location);
        }
        if ($type.isNumber(endPosition) && endPosition != position) {
          position = position + (endPosition - position) * location;
        }
        tick.set("y", this.positionToCoordinate(position));
        var length = tick.get("length", 0);
        var inside = tick.get("inside", this.get("inside", false));
        if (this.get("opposite")) {
          tick.set("x", 0);
          if (inside) {
            length *= -1;
          }
        } else {
          if (!inside) {
            length *= -1;
          }
        }
        tick.set("draw", function (display) {
          display.moveTo(0, 0);
          display.lineTo(length, 0);
        });
        this.toggleVisibility(tick, position, tick.get("minPosition", 0), tick.get("maxPosition", 1));
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "updateBullet",
    value: function updateBullet(bullet, position, endPosition) {
      if (bullet) {
        var sprite = bullet.get("sprite");
        if (sprite) {
          if (!$type.isNumber(position)) {
            position = 0;
          }
          var location = bullet.get("location", 0.5);
          if ($type.isNumber(endPosition) && endPosition != position) {
            position = position + (endPosition - position) * location;
          }
          var bulletPosition = this.axis.roundAxisPosition(position, location);
          var previousBullet = this.axis._bullets[bulletPosition];
          var d = 1;
          if (this.get("opposite")) {
            d = -1;
          }
          if (bullet.get("stacked")) {
            if (previousBullet) {
              var previousSprite = previousBullet.get("sprite");
              if (previousSprite) {
                sprite.set("x", previousSprite.x() + previousSprite.width() * d);
              }
            } else {
              sprite.set("x", 0);
            }
          }
          this.axis._bullets[bulletPosition] = bullet;
          sprite.set("y", this.positionToCoordinate(position));
          this.toggleVisibility(sprite, position, 0, 1);
        }
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "updateFill",
    value: function updateFill(fill, position, endPosition) {
      if (fill) {
        if (!$type.isNumber(position)) {
          position = 0;
        }
        if (!$type.isNumber(endPosition)) {
          endPosition = 1;
        }
        var y0 = this.positionToCoordinate(position);
        var y1 = this.positionToCoordinate(endPosition);
        this.fillDrawMethod(fill, y0, y1);
      }
    }
  }, {
    key: "fillDrawMethod",
    value: function fillDrawMethod(fill, y0, y1) {
      var _this2 = this;
      fill.set("draw", function (display) {
        // using for holes, so can not be rectangle
        var w = _this2.axis.gridContainer.width();
        var h = _this2.height();
        if (y1 < y0) {
          var _ref = [y0, y1];
          y1 = _ref[0];
          y0 = _ref[1];
        }
        if (y0 > h || y1 < 0) {
          return;
        }
        //y0 = Math.max(0, y0);
        //y1 = Math.min(h, y1);
        display.moveTo(0, y0);
        display.lineTo(w, y0);
        display.lineTo(w, y1);
        display.lineTo(0, y1);
        display.lineTo(0, y0);
      });
    }
    /**
     * Converts relative position (0-1) on axis to a pixel coordinate.
     *
     * @param position  Position (0-1)
     * @return Coordinate (px)
     */
  }, {
    key: "positionToCoordinate",
    value: function positionToCoordinate(position) {
      if (!this._inversed) {
        return (this._end - position) * this._axisLength;
      } else {
        return (position - this._start) * this._axisLength;
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "positionTooltip",
    value: function positionTooltip(tooltip, position) {
      this._positionTooltip(tooltip, {
        x: 0,
        y: this.positionToCoordinate(position)
      });
    }
    /**
     * @ignore
     */
  }, {
    key: "updateTooltipBounds",
    value: function updateTooltipBounds(tooltip) {
      var inside = this.get("inside");
      var num = 100000;
      var global = this._display.toGlobal({
        x: 0,
        y: 0
      });
      var y = global.y;
      var x = 0;
      var h = this.axisLength();
      var w = num;
      var pointerOrientation = "right";
      if (this.get("opposite")) {
        if (inside) {
          pointerOrientation = "right";
          x = global.x - num;
          w = num;
        } else {
          pointerOrientation = "left";
          x = global.x;
          w = num;
        }
      } else {
        if (inside) {
          pointerOrientation = "left";
          x = global.x;
          w = num;
        } else {
          pointerOrientation = "right";
          x = global.x - num;
          w = num;
        }
      }
      var bounds = {
        left: x,
        right: x + w,
        top: y,
        bottom: y + h
      };
      var oldBounds = tooltip.get("bounds");
      if (!$utils.sameBounds(bounds, oldBounds)) {
        tooltip.set("bounds", bounds);
        tooltip.set("pointerOrientation", pointerOrientation);
      }
    }
  }, {
    key: "_updateLC",
    value: function _updateLC() {
      var axis = this.axis;
      var parent = axis.parent;
      if (parent) {
        var h = parent.innerHeight();
        this._lc = this.axisLength() / h;
        this._ls = axis.y() / h;
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "toAxisPosition",
    value: function toAxisPosition(position) {
      var start = this._start || 0;
      var end = this._end || 1;
      position -= this._ls;
      position = position * (end - start) / this._lc;
      if (this.get("inversed")) {
        position = start + position;
      } else {
        position = end - position;
      }
      return position;
    }
    /**
     * @ignore
     */
  }, {
    key: "fixPosition",
    value: function fixPosition(position) {
      if (!this.get("inversed")) {
        return 1 - position;
      }
      return position;
    }
  }]);
  return AxisRendererY;
}(AxisRenderer);
Object.defineProperty(AxisRendererY, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisRendererY"
});
Object.defineProperty(AxisRendererY, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: AxisRenderer.classNames.concat([AxisRendererY.className])
});